import * as _ from "lodash";
import * as log from "loglevel";
import * as moment from "moment";
import * as React from "react";

import { inject, observer } from "mobx-react";
import { AuthStore } from "../../stores/auth-store";
import { Project, ProjectAccess, UserApp } from "../../stores/models/project";
import { AppStore } from "../../stores/app-store";

interface IProjectListItemProps{
	project: Project;
	pinned: boolean;
	authStore?: AuthStore;
	appStore?: AppStore;
	onTogglePin(e, project: Project): void;
	onEditProject(e, project: Project): void;
	onShowAppControl(e, project: Project): void;
	onShowDetails(e, project: Project): void;
}

interface IProjectListItemState{

}

@inject("authStore", "appStore") @observer
export class ProjectListItem extends React.Component<IProjectListItemProps, IProjectListItemState>
{
	constructor(props, state){
		super(props, state);
		this.state = {};
	}


	render(){
		const { project } = this.props;
		let pinned = this.props.pinned ? this.props.pinned : false;

		if(_.isNil(project)){
			return null;
		}

		let dueDate : string = "";
		let usePurge = false;
		if(project.purgeDate && project.purgeDate.length > 0){
			usePurge = true;
			dueDate = moment(project.purgeDate.split("T")[0]).format("M/D/YYYY");
		}
		else if(project.testLinkDue && project.testLinkDue.length > 0){
			dueDate = moment(project.testLinkDue.split("T")[0]).format("M/D/YYYY");
		}


		let client = this.props.authStore.user.accountType !== 0;
		let color = project.color;
		let status = project.status;
		let surveyProject = project.surveyId;

		if(client){
			switch(project.status){
				case "New Project":
				case "Configuration":
				case "Programming":
				case "Testing":
					color = "jibunu-orange";
					status = "In Production";
					break;
				default:
					break;
			}
		}

		return(
			<div className={`item ${color}-borderColor`} key={project.id} style={{"borderLeftWidth": "6px", "borderLeftStyle": "solid", "borderBottom": "6px solid", "backgroundColor": "white"}} >
				<div className="right floated content">
					{project.hasAccess(ProjectAccess.EditMembers) && project.status != "Internal" &&
						<a onClick={(e) => this.props.onEditProject(e, project)} data-tooltip="Add/Remove Members">
							<i className={`large ui icon add user ${color}`}></i>
						</a>
					}
					{this.props.authStore.user.accountType == 0 &&
						<a onClick={(e) => this.props.onShowAppControl(e, project)} data-tooltip="Application Control">
							<i className={`large ui icon options ${color}`}></i>
						</a>
					}
					{_.sortBy(project.userApps, ["name"]).map((app: UserApp) => {
						let foundApp = this.props.appStore.findById(app.id);
						return(
								<a target="_blank" href={app.disabled ? null : foundApp.url + "?jpt=" + app.token} key={app.id} data-tooltip={`${foundApp.name}${app.disabled ? " (not active)" : ""}`} style={{"cursor": app.disabled ? "default" : "pointer"}}>
									<i className={`large icon ${foundApp.icon} ${app.disabled ? `jibunu-gray` : `jibunu-blue`}`}></i>
								</a>
							);
						})
					}
					<a className="jibunu-black" onClick={(e) => this.props.onTogglePin(e, project)}>
						<i className={`large icon pin ${color}${pinned ? "" : " clockwise rotated"}`}></i>
					</a>
				</div>
				<div className="content" onClick={(e) => this.props.onShowDetails(e, project)}>
					<div className="header">{project.surveyId} - {project.name}</div>
				</div>
				<div className="content" onClick={(e) => this.props.onShowDetails(e, project)}>
					<div>{project.clientName} - {project.clientProjectName}</div>
					<div>Status: {status}</div>
					{surveyProject &&
					<div>
						<span>
							{usePurge ?
									(status === "Purged" ?
										<b>Data Was Purged On</b>
									:
										<b>Purge Date</b>
									)
								:
									<b>Test Link Due</b>
							}
							: <span>{dueDate}</span>
						</span>
					</div>
					}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/projects/project-list-item.tsx